(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 1007px)';

  function prepareImages(slider) {
    var images = slider.querySelectorAll('.Product__SlideItem img');

    Array.prototype.forEach.call(images, function (img, index) {
      img.classList.remove('Image--lazyLoad', 'Image--lazyLoading', 'Image--fadeIn');
      img.style.opacity = '1';
      img.style.visibility = 'visible';

      if (!img.getAttribute('src') && img.getAttribute('data-src')) {
        img.setAttribute('src', img.getAttribute('data-src').replace('{width}', index === 0 ? '800' : '700'));
      }

      if (!img.getAttribute('srcset') && img.getAttribute('data-srcset')) {
        img.setAttribute('srcset', img.getAttribute('data-srcset'));
      }

      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');

      if (index === 0) {
        img.setAttribute('fetchpriority', 'high');
      }
    });
  }

  function destroyFlickity(slider) {
    if (typeof window.Flickity !== 'function') return;

    var instance = null;

    try {
      if (typeof window.Flickity.data === 'function') {
        instance = window.Flickity.data(slider);
      }
    } catch (error) {}

    if (!instance && slider.flickityInstance) {
      instance = slider.flickityInstance;
    }

    if (instance && typeof instance.destroy === 'function') {
      try {
        instance.destroy();
      } catch (error) {}
    }
  }

  function getDirectChild(parent, className) {
    var children = parent.children;
    for (var i = 0; i < children.length; i += 1) {
      if (children[i].classList && children[i].classList.contains(className)) {
        return children[i];
      }
    }
    return null;
  }

  function unwrapFlickity(slider) {
    var viewport = getDirectChild(slider, 'flickity-viewport');

    if (viewport) {
      var track = viewport.querySelector('.flickity-slider');
      if (track) {
        while (track.firstChild) {
          slider.insertBefore(track.firstChild, viewport);
        }
      }
      viewport.parentNode.removeChild(viewport);
    }

    var flickityDots = getDirectChild(slider, 'flickity-page-dots');
    if (flickityDots && flickityDots.parentNode) {
      flickityDots.parentNode.removeChild(flickityDots);
    }
  }

  function getInitialIndex(slider) {
    var config = slider.getAttribute('data-flickity-config');
    if (!config) return 0;

    try {
      var parsed = JSON.parse(config);
      return Number(parsed.initialIndex) || 0;
    } catch (error) {
      return 0;
    }
  }

  function syncThemeNavigation(gallery, activeIndex) {
    var dots = gallery.querySelectorAll('.Product__SlideshowNavDot');
    var thumbs = gallery.querySelectorAll('.Product__SlideshowNavImage');

    Array.prototype.forEach.call(dots, function (dot, index) {
      dot.classList.toggle('is-selected', index === activeIndex);
    });

    Array.prototype.forEach.call(thumbs, function (thumb, index) {
      thumb.classList.toggle('is-selected', index === activeIndex);
    });
  }

  function setActiveDot(pagination, activeIndex) {
    var dots = pagination.querySelectorAll('.ss-product-native__dot');

    Array.prototype.forEach.call(dots, function (dot, index) {
      var active = index === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function scrollToSlide(track, index, smooth) {
    var width = track.clientWidth || 1;
    var left = width * index;

    try {
      track.scrollTo({
        left: left,
        top: 0,
        behavior: smooth ? 'smooth' : 'auto'
      });
    } catch (error) {
      track.scrollLeft = left;
    }
  }

  function buildNativeGallery(gallery, slider) {
    unwrapFlickity(slider);

    var slides = [];
    var children = Array.prototype.slice.call(slider.children);

    children.forEach(function (child) {
      if (child.classList && child.classList.contains('Product__SlideItem')) {
        slides.push(child);
      }
    });

    if (!slides.length) return;

    var initialIndex = Math.min(getInitialIndex(slider), slides.length - 1);
    var track = document.createElement('div');
    track.className = 'ss-product-native__track';

    slides.forEach(function (slide) {
      slide.classList.remove('Carousel__Cell', 'is-selected', 'swiper-slide');
      slide.classList.add('ss-product-native__slide');
      slide.removeAttribute('style');
      track.appendChild(slide);
    });

    var oldWrapper = slider.querySelector('.swiper-wrapper');
    if (oldWrapper && oldWrapper.parentNode === slider) {
      oldWrapper.parentNode.removeChild(oldWrapper);
    }

    var oldPagination = slider.querySelector('.ss-product-swiper__pagination');
    if (oldPagination && oldPagination.parentNode) {
      oldPagination.parentNode.removeChild(oldPagination);
    }

    slider.appendChild(track);

    var pagination = document.createElement('div');
    pagination.className = 'ss-product-native__pagination';
    pagination.setAttribute('aria-label', 'Produktbilder');

    slides.forEach(function (_, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ss-product-native__dot';
      dot.setAttribute('aria-label', 'Produktbild ' + (index + 1) + ' anzeigen');
      dot.addEventListener('click', function () {
        scrollToSlide(track, index, true);
      });
      pagination.appendChild(dot);
    });

    slider.appendChild(pagination);

    slider.classList.remove('Carousel', 'flickity-enabled', 'is-draggable', 'swiper', 'ss-product-swiper');
    slider.classList.add('ss-product-native');
    slider.removeAttribute('tabindex');

    var scheduled = false;
    var activeIndex = initialIndex;

    function updateActive() {
      scheduled = false;
      var width = track.clientWidth || 1;
      var index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));

      if (index !== activeIndex) {
        activeIndex = index;
      }

      syncThemeNavigation(gallery, activeIndex);
      setActiveDot(pagination, activeIndex);
    }

    track.addEventListener('scroll', function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateActive);
    }, { passive: true });

    var navItems = gallery.querySelectorAll('.Product__SlideshowNavDot, .Product__SlideshowNavImage');
    Array.prototype.forEach.call(navItems, function (item, index) {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToSlide(track, index, true);
      });
    });

    syncThemeNavigation(gallery, initialIndex);
    setActiveDot(pagination, initialIndex);

    window.requestAnimationFrame(function () {
      scrollToSlide(track, initialIndex, false);
      updateActive();
    });

    window.addEventListener('resize', function () {
      scrollToSlide(track, activeIndex, false);
    });

    gallery.dataset.ssProductSwiperInitialized = 'true';
  }

  function initGallery(gallery) {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    if (gallery.dataset.ssProductSwiperInitialized === 'true') return;

    var slider = gallery.querySelector('.Product__Slideshow');
    if (!slider) return;

    prepareImages(slider);
    destroyFlickity(slider);

    window.requestAnimationFrame(function () {
      buildNativeGallery(gallery, slider);
    });
  }

  function boot(scope) {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;

    var root = scope || document;
    var galleries = root.querySelectorAll ? root.querySelectorAll('.Product__Gallery') : [];
    Array.prototype.forEach.call(galleries, initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
}());
